// From https://github.com/radial-color-picker/color-wheel

import angleToColor from './angleToColor'

export default function paintColorWheelToCanvas(canvas: HTMLCanvasElement, size: number) {
  const half = size / 2
  const deg = Math.PI / 180
  const pi2 = Math.PI * 2

  canvas.width = canvas.height = size
  const ctx = canvas.getContext('2d')

  if (!ctx) {
    return canvas
  }

  // .02: To prevent empty blank line and corresponding moire
  // only non-alpha colors are cared now
  const thetaOffset = 0.5 * deg + 0.02

  // Transform coordinate system so that angles start from the top left, like in CSS
  ctx.translate(half, half)
  ctx.rotate(-Math.PI / 2)
  ctx.translate(-half, -half)

  for (let i = 0; i < 360; i += 0.5) {
    ctx.fillStyle = angleToColor(i)
    ctx.beginPath()
    ctx.moveTo(half, half)

    const beginArg = i * deg
    const endArg = Math.min(pi2, beginArg + thetaOffset)

    ctx.arc(half, half, half, beginArg, endArg)

    ctx.closePath()
    ctx.fill()
  }

  return canvas
}
